import { AppBar, Box, Drawer, Stack, Toolbar, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { NavItem } from './components/NavItem';

const DRAWER_WIDTH = 255;

export const App = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppBar position="static" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" fontWeight="bold">
            Radius Proxy
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Drawer
          variant="permanent"
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              boxSizing: 'border-box',
              position: 'relative',
            },
          }}
        >
          <Stack spacing={1} sx={{ p: 2 }}>
            <NavItem to="/subscribers">Subscribers</NavItem>
            <NavItem to="/bng-ip-lookup">BNG IP Lookup</NavItem>
            <NavItem to="/usoc">USOC Mappings</NavItem>
          </Stack>
        </Drawer>

        <Box component="main" sx={{ flex: 1, p: 3, overflow: 'auto', bgcolor: 'grey.50' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
